(() => {
  // ---------------------- config ----------------------
  const getMeta = (name) => document.querySelector(`meta[name="${name}"]`)?.getAttribute('content') || null;
  const SF_ENDPOINT = getMeta('storefront-api-endpoint') || '/api/2024-07/graphql.json';
  const SF_TOKEN = getMeta('storefront-api-token'); // if null, we fail open to normal search

  // Adjust this to your article-number format if needed
  const looksLikeSku = (str) => /^[A-Z0-9][A-Z0-9\-._/ ]{1,63}$/i.test((str || '').trim());

  // ---------------------- Storefront lookup ----------------------
  async function findVariantBySku(raw) {
    if (!SF_TOKEN) return null;

    const q = (raw || '').trim();
    if (!q) return null;

    const query = `
      query($q: String!) {
        productVariants(first: 10, query: $q) {
          edges {
            node {
              id
              sku
              product { handle }
            }
          }
        }
      }
    `;

    // Try exact quoted match first, then a looser pass
    const clauses = [
      `sku:"${q.replace(/"/g, '\\"')}"`,
      `sku:${q}`
    ];

    for (const clause of clauses) {
      const res = await fetch(SF_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': SF_TOKEN
        },
        body: JSON.stringify({ query, variables: { q: clause } }),
        credentials: 'same-origin'
      }).catch(() => null);

      if (!res || !res.ok) continue;

      const json = await res.json().catch(() => null);
      const edges = json?.data?.productVariants?.edges || [];
      if (!edges.length) continue;

      // prefer exact SKU match (trim + case-insensitive)
      const exact = edges.find(e => (e?.node?.sku || '').trim().toLowerCase() === q.toLowerCase());
      const node = (exact || edges[0])?.node;
      if (node?.product?.handle && node?.id) return node;
    }

    return null;
  }

  // GID → numeric id (for ?variant=)
  const gidToId = (gid) => (gid || '').split('/').pop();

  // ---------------------- wiring into Focal ----------------------
  function attachHandlers() {
    // Main search page form
    const mainForms = Array.from(document.querySelectorAll('form.main-search__form[action*="/search"], form.main-search__form[action^="{{ routes.search_url }}"]'));

    // Header predictive search form (your snippet uses this ID)
    const predictiveForm = document.getElementById('predictive-search-form');
    const forms = [...mainForms, ...(predictiveForm ? [predictiveForm] : [])];

    if (!forms.length) return;

    forms.forEach((form) => {
      form.addEventListener('submit', async (ev) => {
        try {
          const input = form.querySelector('input[name="q"], input[type="search"]');
          const val = (input?.value || '').trim();
          if (!val || !looksLikeSku(val)) return; // let normal search proceed

          // prevent default while we try SKU resolution
          ev.preventDefault();

          const variant = await findVariantBySku(val);

          if (variant?.product?.handle) {
            const id = gidToId(variant.id);
            // Respect current language/market subpath/domain automatically
            const origin = window.location.origin;
            const href = `${origin}/products/${variant.product.handle}?variant=${encodeURIComponent(id)}`;
            window.location.assign(href);
          } else {
            // no match → proceed with normal search
            form.submit();
          }
        } catch (err) {
          // Any error: gracefully fall back
          try { form.submit(); } catch(e) {}
        }
      }, { capture: true });
    });
  }

  // Focal swaps DOM in places; re-attach on ready + on page changes
  const onReady = () => attachHandlers();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // Attempt to re-bind after Focal async nav (if using Instant/Page transitions)
  document.addEventListener('page:loaded', attachHandlers, { passive: true });
  document.addEventListener('shopify:section:load', attachHandlers, { passive: true });
})();
